import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';

import BaseBox from '../../internal/components/BaseBox';
import { Body } from '../../typography';

const ValidationErrorMessageContainer = styled(BaseBox)(
  css({
    width: '100%',
    py: 'tiny',
  })
);

export const ValidationErrorMessage = forwardRef(
  ({ invalid, children, ...rest }, ref) => {
    return invalid ? (
      <ValidationErrorMessageContainer ref={ref} {...rest}>
        <Body color="red.50" type="xSmall">
          {children}
        </Body>
      </ValidationErrorMessageContainer>
    ) : null;
  }
);
